
import { mapGetters } from 'vuex'

export default {
layout: 'fullscreen',
computed: {
  ...mapGetters({
    isLoggedIn:'user/isLoggedIn',
    jwt: 'user/jwt'
  })
},
mounted(){
  if(this.isLoggedIn && this.jwt){
    this.$router.push('/my-account/dashboard/')
  }
}
}
